import { render, staticRenderFns } from "./InertClockInItem.vue?vue&type=template&id=67f9f45e"
import script from "./InertClockInItem.vue?vue&type=script&lang=js"
export * from "./InertClockInItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports